var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialOutlineAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.294 7.755a.833.833 0 011.118.372l.431.862a4.999 4.999 0 014.314 0l.431-.862a.833.833 0 111.49.746l-.544 1.09.002.001A5 5 0 0121 13.5v6.667a1.667 1.667 0 01-1.667 1.666V23.5a.833.833 0 11-1.666 0v-1.667h-3.334V23.5a.833.833 0 11-1.666 0v-1.667A1.666 1.666 0 0111 20.167V13.5a5 5 0 011.464-3.536l.002-.001-.545-1.09a.833.833 0 01.373-1.118zm1.695 3.087a3.341 3.341 0 00-1.216 1.825h6.454a3.333 3.333 0 00-5.238-1.825zm5.344 3.491h-6.666v5.834h6.666v-5.834zm-10-.833c.46 0 .834.373.834.833v5a.833.833 0 01-1.667 0v-5c0-.46.373-.833.833-.833zm13.334 0c.46 0 .833.373.833.833v5a.833.833 0 01-1.667 0v-5c0-.46.373-.833.834-.833z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-social-outline--Android-4da2a0578fbd494a53a89b6f2f756f99.svg";
export { SvgIconSocialOutlineAndroid as Component };